import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';

export function initDayjs(): void {
    dayjs.extend(isBetween);
}
